export const defaultSorted = [{dataField: "priority", order: "asc"}];
export const sizePerPageList = [
    {text: "3", value: 3},
    {text: "5", value: 5},
    {text: "15", value: 15}
];
export const initialFilter = {
    filter: {
        vin: "",
        make: "",
        model: "",
        modelYear: ""
    },
    sortOrder: "asc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 15
};